import React from "react";
import { Link } from "react-router-dom";
import { Scale, ArrowRight } from "lucide-react";

const BG =
  "https://images.unsplash.com/photo-1505664194779-8beaceb93744?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsYXclMjBsaWJyYXJ5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODY4OTE0NDh8MA&ixlib=rb-4.1.0&q=85";

export const CtaBanner = () => (
  <section data-testid="landing-cta-banner" className="relative overflow-hidden bg-navy px-4 py-20 sm:px-6 lg:px-8">
    <img src={BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" />
    <div aria-hidden="true" className="absolute inset-0 bg-navy/80" />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-32 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-gold/20 blur-3xl"
    />
    <div className="relative mx-auto max-w-2xl text-center">
      <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-white/10 text-gold">
        <Scale className="h-6 w-6" strokeWidth={1.75} />
      </span>
      <h2 className="mt-6 font-display text-3xl font-semibold text-white sm:text-4xl">
        Put your chamber in order this week
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-slate-300 sm:text-base">
        Start on the free plan or take a 30-day trial. No card needed to begin.
      </p>
      <Link
        to="/register"
        data-testid="bottom-cta-register"
        className="group mt-8 inline-flex items-center gap-2 rounded-md bg-gold px-7 py-3.5 text-base font-semibold text-navy shadow-lg transition-all hover:-translate-y-0.5 hover:bg-gold-light"
      >
        Create your account
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  </section>
);

const COLS = [
  { title: "Product", links: [["Court diary", "#preview"], ["Features", "#features"], ["Pricing", "/pricing"], ["Payments", "/payment"], ["FAQ", "#faq"]] },
  { title: "Account", links: [["Sign in", "/login"], ["Create account", "/register"], ["Reset password", "/forgot-password"]] },
  { title: "Support", links: [["Contact & Support", "/contact"], ["Security & Data", "/security"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy-policy"], ["Terms of Service", "/terms"], ["Refund Policy", "/refund-policy"]] },
];

export const LandingFooter = () => (
  <footer data-testid="landing-footer" className="bg-[#060F1E] px-4 py-14 text-slate-400 sm:px-6 lg:px-8">
    <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5">
      <div>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-white/10 text-gold">
            <Scale className="h-5 w-5" strokeWidth={1.75} />
          </span>
          <span className="font-display text-xl text-white">Advocate Diary</span>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed">
          Practice management for advocates, chambers and law firms across India.
        </p>
      </div>

      {COLS.map((c) => (
        <div key={c.title}>
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-gold">{c.title}</p>
          <ul className="mt-4 space-y-2.5">
            {c.links.map(([label, href]) => (
              <li key={label}>
                {href.startsWith("#") ? (
                  <a href={href} className="text-sm transition-colors hover:text-white">
                    {label}
                  </a>
                ) : (
                  <Link
                    to={href}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm transition-colors hover:text-white"
                  >
                    {label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="mx-auto mt-12 max-w-6xl border-t border-white/10 pt-6">
      <p className="text-xs">© {new Date().getFullYear()} Advocate Diary. Built for Indian advocates.</p>
    </div>
  </footer>
);
